import { CommunicationService } from "../services/communication.service";
// @ts-ignore
import { ToolbarService } from "@cosmos/utilities";

export class ChangeLayoutTopbarEvent {
  static EVENT_NAME = "changeLayoutTopbar";
  static changeLayoutTopbarEvent: ChangeLayoutTopbarEvent;

  private constructor() {
    this.load();
  }

  static init(): ChangeLayoutTopbarEvent {
    if (!ChangeLayoutTopbarEvent.changeLayoutTopbarEvent) {
      ChangeLayoutTopbarEvent.changeLayoutTopbarEvent = new ChangeLayoutTopbarEvent();
    }
    return ChangeLayoutTopbarEvent.changeLayoutTopbarEvent;
  }

  static destroy() {}

  load() {
    const communicationService = CommunicationService.singleton();
    communicationService.receiveCustomEvent(
      ChangeLayoutTopbarEvent.EVENT_NAME,
      this.changeLayoutTopbar
    );
  }

  changeLayoutTopbar: EventListener = async (event: CustomEvent) => {
    ToolbarService.singleton().setToolbarConfig(event.detail)
  };
}
